import React from 'react'

import './styles.scss'

const SeparatorWithLabel = ({ title }) => {
  return (
    <div className='separator-with-label'>
      <p>{title}</p>
    </div>
  )
}

export default SeparatorWithLabel
